var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChevronDown = function SvgChevronDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-Sheets-+-Guidlines",
    transform: "translate(-64.000000, -1364.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ChevronDown",
    transform: "translate(64.000000, 1364.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7988281,17.2929688 C12.21875,17.2929688 12.5800781,17.1269531 12.9023437,16.8046875 L20.2167969,9.3046875 C20.4707031,9.05078125 20.6074219,8.73828125 20.6074219,8.3671875 C20.6074219,7.60546875 20.0019531,7 19.25,7 C18.8789062,7 18.5273438,7.14648438 18.2539062,7.41992188 L11.8085938,14.0605469 L5.35351562,7.41992188 C5.08007812,7.15625 4.73828125,7 4.35742188,7 C3.60546875,7 3,7.60546875 3,8.3671875 C3,8.73828125 3.13671875,9.05078125 3.390625,9.31445312 L10.7050781,16.8046875 C11.046875,17.1367188 11.3886719,17.2929688 11.7988281,17.2929688 Z",
    id: "\\uDBC0\\uDD88",
    fill: "#FD5F55",
    fillRule: "nonzero"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-down.2b2ed5e5.svg";
export { ForwardRef as ReactComponent };